import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { OverlayTrigger, Tooltip, ProgressBar, Modal, Button, Spinner } from "react-bootstrap";

import Swal from "sweetalert2";
import AuthService from "../../services/auth.service";


const PackagesCRUD = () => {
  const [packages, setPackages] = useState([]);
  const [formData, setFormData] = useState({
   // Id: "",
    Package: "",
   // CatId: "",
   // Downloadable: false,
    Price: 0,
  //  FirstInserted: "",
    Discription: "",
    Sku: "",
    WPacks: null,
    IsActive: false,
    PackageCode: null,
    IsPayable: false,
    Monthly: 0,
    Yearly: 0,
    SpOrder: 0,
  });

  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const [editingId, setEditingId] = useState(null);
  const API_BASE_URL = "https://s3napi-dev.s3nsoftware.com/api/UserMasters";

  useEffect(() => {
    fetchPackages();


    const username =  localStorage.getItem("username");

    AuthService.getUserRole(username).then((response) => {
        if (response.UserRole === "No User") {
          alert("No User");
          return;
        }
        if (response.UserRole === "SuperAdmin") {
          // alert("Admin");
          return;
        }else{
          alert("You are not authorized to access this page");
          window.location.href = "*";
        }
      });

  }, []);

  const fetchPackages = async () => {
    setLoading(true);
    setProgress(30);
    try {
      const response = await axios.get(`${API_BASE_URL}/GetPackages`);
      setPackages(response.data);
      setPackages(response.data);
      setProgress(100);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateForm = () => {
    let newErrors = {};
  
    // Mandatory Fields
   // if (!formData.Id) newErrors.Id = "Package ID is required.";
    if (!formData.Package) newErrors.Package = "Package Name is required.";
   // if (!formData.CatId) newErrors.CatId = "Category ID is required.";
    if (!formData.Price) newErrors.Price = "Price is required.";
 //   if (!formData.FirstInserted) newErrors.FirstInserted = "Date is required.";
    if (formData.IsActive === null) newErrors.IsActive = "Active status is required.";
  
    // Numeric Validations
    if (formData.Price && isNaN(formData.Price)) newErrors.Price = "Price must be a number.";
    if (formData.Monthly && isNaN(formData.Monthly)) newErrors.Monthly = "Monthly price must be a number.";
    if (formData.Yearly && isNaN(formData.Yearly)) newErrors.Yearly = "Yearly price must be a number.";
    if (formData.SpOrder && isNaN(formData.SpOrder)) newErrors.SpOrder = "Sort Order must be an integer.";
  
    // Length Validations (Ensuring fields are not null)
    if ((formData.Package || "").length > 150) newErrors.Package = "Package Name cannot exceed 150 characters.";
    if ((formData.Sku || "").length > 15) newErrors.Sku = "SKU cannot exceed 15 characters.";
    if ((formData.PackageCode || "").length > 50) newErrors.PackageCode = "Package Code cannot exceed 50 characters.";
    if ((formData.Discription || "").length > 1000) newErrors.Discription = "Description cannot exceed 1000 characters.";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; // Stop if validation fails


    setLoading(true);
    setProgress(50);

    try {
      if (editingId) {
        await axios.post(`${API_BASE_URL}/UpdatePackage/${editingId}`, formData);
      } else {
        await axios.post(`${API_BASE_URL}/CreatePackage`, formData);
      }
      fetchPackages();
      resetForm();
    } catch (error) {
      console.error("Error submitting package:", error);
    }finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  const resetForm = () => {
    setFormData({
      //Id: "",
      Package: "",
    //  CatId: "",
      Downloadable: false,
      Price: 0,
     // FirstInserted: "",
      Discription: "",
      Sku: "",
      WPacks: null,
      IsActive: false,
      PackageCode: null,
      IsPayable: false,
      Monthly: 0,
      Yearly: 0,
      SpOrder: 0,
    });
    setEditingId(null);
  };

  const handleEdit = (pkg) => {
    setFormData(pkg);
    setEditingId(pkg.Id);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this package? This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      setLoading(true);
      setProgress(50);
      try {
        await axios.get(`${API_BASE_URL}/DeletePackage/${id}`);
        fetchPackages();
        Swal.fire("Deleted!", "The package has been deleted.", "success");
      } catch (error) {
        console.error("Error deleting package:", error);
      } finally {
        setTimeout(() => setLoading(false), 500);
      }
    }
  };


  const fieldInstructions = {
   // Id: { label: "Package ID", description: "Unique identifier.", example: "Ex: 24" },
    Package: { label: "Package Name", description: "Name of the package.", example: "Ex: 1 Year Bee Preparation" },
   // CatId: { label: "Category ID", description: "Package category.", example: "Ex: 5" },
    Downloadable: { label: "Downloadable", description: "Can be downloaded?", example: "Ex: Yes/No" },
    Price: { label: "Price ($)", description: "Cost of the package.", example: "Ex: 499" },
    Discription: { label: "Description", description: "Details of the package.", example: "Ex: Full access included" },
    Sku: { label: "SKU", description: "Stock keeping unit ID.", example: "Ex: PKG001" },
    WPacks: { label: "Word Packs", description: "Number of packs included.", example: "Ex: 10" },
    IsActive: { label: "Active", description: "Is it active?", example: "Ex: Yes/No" },
    PackageCode: { label: "Package Code", description: "Unique package code.", example: "Ex: ABC123" },
    IsPayable: { label: "Payable", description: "Is it a payable package?", example: "Ex: Yes/No" },
    Monthly: { label: "Monthly Price ($)", description: "Subscription cost per month.", example: "Ex: 49.99" },
    Yearly: { label: "Yearly Price ($)", description: "Subscription cost per year.", example: "Ex: 499" },
    SpOrder: { label: "Sort Order", description: "Display order of the package.", example: "Ex: 1" },
  };
  const [errors, setErrors] = useState({});


  
  

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-extrabold text-center text-indigo-600 mb-6">
        🎨 Manage Spelling Packages
      </h1>

      {loading && <ProgressBar animated now={progress} label={`${progress}%`} className="mb-3" />}

{/* Circular Progress Loader */}
{loading && (
        <div className="text-center mb-3">
          <Spinner animation="border" variant="primary" size="lg" />
          <p>Loading...</p>
        </div>
      )}

      {/* Form Section */}
      <div className="bg-white shadow-lg rounded-xl p-6 mb-8 w-full">
        <h2 className="text-xl font-bold mb-4 text-gray-800">
          {editingId ? "✏️ Edit Package" : "➕ Create Package"}
        </h2>
        <form onSubmit={handleSubmit}>
          <table className="table table-striped table-hover table-bordered w-100">
            <thead className="table-dark">
              <tr>
                <th className="py-2 px-2">Field Name</th>
                <th className="py-2 px-2">Input</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(formData).map((key) => (
                <tr key={key} className="align-middle">
                  <td className="py-1 px-2 font-semibold text-gray-800">
                    {key}{" "}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-${key}`}>
                          <strong>{key}:</strong> Enter the required value.
                        </Tooltip>
                      }
                    >
                      <span className="text-info cursor-pointer"> ℹ️</span>
                    </OverlayTrigger>
                  </td>
                  <td className="py-1 px-2">
                    {typeof formData[key] === "boolean" ? (
                      <input
                        type="checkbox"
                        name={key}
                        checked={formData[key]}
                        onChange={handleChange}
                        className="form-check-input"
                      />
                    ) : (
                      <input
                        type={typeof formData[key] === "number" ? "number" : "text"}
                        name={key}
                        value={formData[key] || ""}
                        onChange={handleChange}
                        className="form-control form-control-sm"
                      />
                    )}
                    {errors[key] && <div className="text-danger small">{errors[key]}</div>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-center mt-3">
            <button type="submit" className="btn btn-danger btn-sm">
              {editingId ? "Update Package" : "Create Package"}
            </button>
          </div>
        </form>
      </div>

      {/* Packages Table */}
      <table className="table table-striped table-hover table-bordered w-100">
        <thead className="table-dark">
          <tr>
            {Object.keys(formData).map((key) => (
              <th key={key} className="py-2 px-2">{fieldInstructions[key]?.label || key}</th>
            ))}
            <th className="py-2 px-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {packages.map((pkg) => (
            <tr key={pkg.Id}>
              {Object.keys(formData).map((key) => (
                <td key={key} className="py-1 px-2">{pkg[key]}</td>
              ))}
              <td className="py-1 px-2 text-center">
                <button className="btn btn-warning btn-sm mx-1" onClick={() => handleEdit(pkg)}>✏️</button>
                <button className="btn btn-danger btn-sm mx-1" onClick={() => handleDelete(pkg.Id)}>❌</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PackagesCRUD;
